'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["conversation", "selected", "unread", "focused", "ownerState", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useChatLocaleText } from "../chat/internals/ChatLocaleContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const ConversationListTimestamp = /*#__PURE__*/React.forwardRef(function ConversationListTimestamp(props, ref) {
  const _ref = props,
    {
      conversation,
      selected = false,
      unread = false,
      focused = false,
      ownerState: ownerStateProp,
      slots,
      slotProps
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  const ownerState = {
    conversation,
    selected,
    unread,
    focused
  };
  void ownerStateProp;
  const localeText = useChatLocaleText();
  const Root = slots?.root ?? 'div';
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    }
  });
  if (!conversation.lastMessageAt) {
    return null;
  }
  return /*#__PURE__*/_jsx(Root, _extends({}, rootProps, {
    children: /*#__PURE__*/_jsx("time", {
      dateTime: conversation.lastMessageAt,
      suppressHydrationWarning: true,
      children: localeText.conversationTimestampLabel(conversation.lastMessageAt)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ConversationListTimestamp.displayName = "ConversationListTimestamp";